import React from 'react';
import './NotFound.css';

export const NotFound = () => (<span>404</span>);



// WEBPACK FOOTER //
// ./src/components/NotFound/NotFound.jsx